import { useScanRawAlarms } from '@hakimo-ui/hakimo/data-access';
import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import ScanRawAlarmDetails from './ScanRawAlarmDetails';

interface Props {
  eventId: string;
}

export function ScanRawAlarmDetailsData({ eventId }: Props) {
  const queryResult = useScanRawAlarms(eventId);
  const { refetch } = queryResult;

  return (
    <QueryResult queryResult={queryResult}>
      {(data: UnifiedAlarm) => (
        <ScanRawAlarmDetails event={data} onRefresh={() => refetch()} />
      )}
    </QueryResult>
  );
}
